import { render, staticRenderFns } from "./marketingReportLk.vue?vue&type=template&id=6db3d40e&scoped=true"
import script from "./marketingReportLk.vue?vue&type=script&lang=js"
export * from "./marketingReportLk.vue?vue&type=script&lang=js"
import style0 from "./marketingReportLk.vue?vue&type=style&index=0&id=6db3d40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3d40e",
  null
  
)

export default component.exports